module.exports = __webpack_public_path__ + "fa-regular-400.ef60a4f6c25ef7f39f2d.woff";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-regular-400.woff
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-regular-400.woff
// module chunks = styles